module.exports = __webpack_public_path__ + "img/email.5ce90c6a.svg";